import { ProtocolContext } from 'contexts/protocolContext'
import { useContext } from 'react'

export const useProtocolContext = () => useContext(ProtocolContext)
